export const animationBottom = {
  hidden: {
    y: +400,
    opacity: 0,
  },
  visible:{
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.9,
    },
  }
}
